module.exports = __webpack_public_path__ + "img/anna-dickinson.366deadd.png";